import { motion } from 'framer-motion';
import { Coffee } from 'lucide-react';

export function BuyMeCoffee() {
  return (
    <section className="py-16 relative overflow-hidden text-center">
      {/* Background gradient and pattern */}
      <div className="absolute inset-0 bg-gradient-to-br from-amber-50 via-yellow-50 to-orange-50">
        <div className="absolute inset-0 opacity-10">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage: `radial-gradient(circle at 2px 2px, rgba(0,0,0,0.1) 1px, transparent 0)`,
              backgroundSize: '24px 24px'
            }}
          />
        </div>
      </div>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        className="max-w-md mx-auto px-4 relative"
      >
        <h2 className="text-2xl font-bold text-gray-900 mb-4">
          Support the Project
        </h2>
        <p className="text-gray-600 mb-8">
          If you find this tool helpful, consider buying me a coffee to support
          ongoing development!
        </p>
        <motion.a
          href="https://buymeacoffee.com/kcljzfr"
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 bg-[#FFDD00] text-gray-900 px-8 py-4 rounded-xl font-medium hover:bg-[#FFDD00]/90  shadow-lg hover:shadow-xl hover:-translate-y-0.5 transform transition-all duration-200"
          whileHover={{ scale: 1.02 }}
          whileTap={{ scale: 0.98 }}
        >
          <Coffee className="w-5 h-5" />
          Buy me a coffee
        </motion.a>
      </motion.div>
    </section>
  );
}
